import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";

const DraftTable = () => {
  const [draft, setDraft] = useState();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const dashboard = JSON.parse(localStorage.getItem("dashboard"));
  const type = JSON.parse(localStorage.getItem("type"));

  const getSRAs = async () => {
    if (dashboard === "SERVICE") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "INVOICE") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-invoice-approval/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "CUSTOMER") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-customer-approval/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "VENDOR_APPROVAL") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-approval/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "TRADE") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-trade/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "VENDOR") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-balance/get-all?username=${storedUser.username}&type=${type}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "CUSTOMER_BALANCE") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-customer-balance/get-all?username=${storedUser.username}&type=${type}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "ADVANCE") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-advance-given/get-all?username=${storedUser.username}&type=${type}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "DEPOSIT") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-deposit-given/get-all?username=${storedUser.username}&type=${type}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "OTHER") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-other/get-all?username=${storedUser.username}&type=${type}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "CUSTOMER_DEPOSIT") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-customer-deposit/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "TENDER_DEPOSIT") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-tender-deposit/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "VENDOR_ADVANCE") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-advance/get-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "INVENTORY") {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-inventory/get-all?username=${storedUser.username}&type=${type}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    getSRAs();
  }, []);

  const handleCheck = (id) => {
    localStorage.setItem("activeTab", "DRAFTS");
    if (dashboard === "SERVICE") {
      navigate(`/dashboard/create-service-order/draft/${id}`);
    } else if (dashboard === "INVOICE") {
      navigate(`/dashboard/create-invoice-approval/draft/${id}`);
    } else if (dashboard === "CUSTOMER") {
      navigate(`/dashboard/create-customer-approval/draft/${id}`);
    } else if (dashboard === "VENDOR_APPROVAL") {
      navigate(`/dashboard/create-vendor-approval/draft/${id}`);
    } else if (dashboard === "TRADE") {
      navigate(`/dashboard/create-trade/draft/${id}`);
    } else if (dashboard === "VENDOR") {
      navigate(`/dashboard/create-vendor-balance/draft/${id}`);
    } else if (dashboard === "CUSTOMER_BALANCE") {
      navigate(`/dashboard/create-customer-balance/draft/${id}`);
    } else if (dashboard === "ADVANCE") {
      navigate(`/dashboard/create-advance-given/draft/${id}`);
    } else if (dashboard === "DEPOSIT") {
      navigate(`/dashboard/create-deposit-given/draft/${id}`);
    } else if (dashboard === "DEPOSIT") {
      navigate(`/dashboard/create-other/draft/${id}`);
    } else if (dashboard === "CUSTOMER_DEPOSIT") {
      navigate(`/dashboard/create-customer-deposit/draft/${id}`);
    } else if (dashboard === "TENDER_DEPOSIT") {
      navigate(`/dashboard/create-tender-deposit/draft/${id}`);
    } else if (dashboard === "VENDOR_ADVANCE") {
      navigate(`/dashboard/create-vendor-advance/draft/${id}`);
    } else if (dashboard === "INVENTORY") {
      navigate(`/dashboard/create-inventory/draft/${id}`);
    }
  };

  const handleDelete = async (id) => {
    if (dashboard === "SERVICE") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "INVOICE") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-invoice-approval?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "CUSTOMER") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-customer-approval?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "VENDOR_APPROVAL") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-approval?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "TRADE") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-trade?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "VENDOR") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-balance?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "CUSTOMER_BALANCE") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-customer-balance?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "ADVANCE") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-advance-given?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "DEPOSIT") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-deposit-given?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "OTHER") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-other?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "CUSTOMER_DEPOSIT") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-customer-deposit?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "TENDER_DEPOSIT") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-tender-deposit?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "VENDOR_ADVANCE") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-advance?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    } else if (dashboard === "INVENTORY") {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/draft-inventory?draftSraId=${id}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        getSRAs();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getDraftIdByDashboard = (dashboard, row) => {
    switch (dashboard) {
      case "SERVICE":
        return row.draftSraId;
      case "INVOICE":
        return row.draftInvoiceId;
      case "CUSTOMER":
        return row.draftCustomerId;
      case "VENDOR_APPROVAL":
        return row.draftVendorId;
      case "TRADE":
        return row.draftTradeId;
      case "VENDOR":
        return row.draftVendorBalanceId;
      case "CUSTOMER_BALANCE":
        return row.draftCustomerBalanceId;
      case "ADVANCE":
        return row.draftAdvanceId;
      case "DEPOSIT":
        return row.draftDepositId;
      case "OTHER":
        return row.draftOtherId;
      case "CUSTOMER_DEPOSIT":
        return row.draftCustomerDepositId;
      case "TENDER_DEPOSIT":
        return row.draftTenderDepositId;
      case "VENDOR_ADVANCE":
        return row.draftVendorAdvanceId;
      case "INVENTORY":
        return row.draftInventoryId;
      default:
        return row.id;
    }
  };

  const columns = [
    {
      field: "draftSraId",
      headerName: "Draft ID",
      flex: 1,
      renderCell: (params) => (
        <span
          className="table-title"
          onClick={() =>
            handleCheck(
              dashboard === "SERVICE"
                ? params.row.draftSraId
                : dashboard === "INVOICE"
                ? params.row.draftInvoiceId
                : dashboard === "CUSTOMER"
                ? params.row.draftCustomerId
                : dashboard === "VENDOR_APPROVAL"
                ? params.row.draftVendorId
                : dashboard === "TRADE"
                ? params.row.draftTradeId
                : dashboard === "VENDOR"
                ? params.row.draftVendorBalanceId
                : dashboard === "CUSTOMER_BALANCE"
                ? params.row.draftCustomerBalanceId
                : dashboard === "ADVANCE"
                ? params.row.draftAdvanceId
                : dashboard === "DEPOSIT"
                ? params.row.draftDepositId
                : dashboard === "OTHER"
                ? params.row.draftOtherId
                : dashboard === "CUSTOMER_DEPOSIT"
                ? params.row.draftCustomerDepositId
                : dashboard === "TENDER_DEPOSIT"
                ? params.row.draftTenderDepositId
                : dashboard === "VENDOR_ADVANCE"
                ? params.row.draftVendorAdvanceId
                : dashboard === "INVENTORY"
                ? params.row.draftInventoryId
                : params.row.id
            )
          }
        >
          {dashboard === "SERVICE"
            ? params.row.draftSraId
            : dashboard === "INVOICE"
            ? params.row.draftInvoiceId
            : dashboard === "CUSTOMER"
            ? params.row.draftCustomerId
            : dashboard === "VENDOR_APPROVAL"
            ? params.row.draftVendorId
            : dashboard === "TRADE"
            ? params.row.draftTradeId
            : dashboard === "VENDOR"
            ? params.row.draftVendorBalanceId
            : dashboard === "CUSTOMER_BALANCE"
            ? params.row.draftCustomerBalanceId
            : dashboard === "ADVANCE"
            ? params.row.draftAdvanceId
            : dashboard === "DEPOSIT"
            ? params.row.draftDepositId
            : dashboard === "OTHER"
            ? params.row.draftOtherId
            : dashboard === "CUSTOMER_DEPOSIT"
            ? params.row.draftCustomerDepositId
            : dashboard === "TENDER_DEPOSIT"
            ? params.row.draftTenderDepositId
            : dashboard === "VENDOR_ADVANCE"
            ? params.row.draftVendorAdvanceId
            : dashboard === "INVENTORY"
            ? params.row.draftInventoryId
            : params.row.id}
        </span>
      ),
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      renderCell: (params) => (
        <span>
          {dashboard === "SERVICE"
            ? "Service Order"
            : dashboard === "INVOICE"
            ? "Invoice Approval"
            : dashboard === "CUSTOMER"
            ? "New Customer Approval"
            : dashboard === "VENDOR_APPROVAL"
            ? "New Vendor Approval"
            : dashboard === "TRADE"
            ? "Trade Marketing Scheme"
            : dashboard === "VENDOR"
            ? "Write Off - Vendor Balance"
            : dashboard === "CUSTOMER_BALANCE"
            ? "Write Off - Customer Balance"
            : dashboard === "ADVANCE"
            ? "Write Off - Advances Given"
            : dashboard === "DEPOSIT"
            ? "Write Off - Deposit Given"
            : dashboard === "OTHER"
            ? "Write Off - Others"
            : dashboard === "CUSTOMER_DEPOSIT"
            ? "Customer Deposit"
            : dashboard === "TENDER_DEPOSIT"
            ? "Tender Deposit"
            : dashboard === "VENDOR_ADVANCE"
            ? "Vendor Advance"
            : dashboard === "INVENTORY"
            ? "Write Off - Inventory"
            : params.row.id.includes("VB")
            ? "Write Off - Vendor Balance"
            : "Service Order"}
        </span>
      ),
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => {
        const draftId = getDraftIdByDashboard(dashboard, params.row);

        return (
          <Button
            sx={{ padding: "0 !important", minWidth: "0px !important" }}
            onClick={() => handleDelete(draftId)}
            color="#c7c7c7"
          >
            <DeleteIcon />
          </Button>
        );
      },
    },
  ];

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const cleanTime = time?.split(".")[0];
    return `${day}/${month}/${year} ${cleanTime}`;
  };

  const draftRows =
    draft &&
    draft.map((draft) => ({
      ...draft,
      createdDate: formatDateTime(draft.createdDate),
    }));

  return (
    <Box sx={{ background: "#fff" }}>
      <DataGrid
        rows={draftRows}
        columns={columns}
        //   loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) =>
          dashboard === "SERVICE"
            ? row.draftSraId
            : dashboard === "INVOICE"
            ? row.draftInvoiceId
            : dashboard === "CUSTOMER"
            ? row.draftCustomerId
            : dashboard === "VENDOR_APPROVAL"
            ? row.draftVendorId
            : dashboard === "TRADE"
            ? row.draftTradeId
            : dashboard === "VENDOR"
            ? row.draftVendorBalanceId
            : dashboard === "CUSTOMER_BALANCE"
            ? row.draftCustomerBalanceId
            : dashboard === "ADVANCE"
            ? row.draftAdvanceId
            : dashboard === "DEPOSIT"
            ? row.draftDepositId
            : dashboard === "OTHER"
            ? row.draftOtherId
            : dashboard === "CUSTOMER_DEPOSIT"
            ? row.draftCustomerDepositId
            : dashboard === "TENDER_DEPOSIT"
            ? row.draftTenderDepositId
            : dashboard === "VENDOR_ADVANCE"
            ? row.draftVendorAdvanceId
            : dashboard === "INVENTORY"
            ? row.draftInventoryId
            : null
        }
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          position: "relative",
          border: "none",
          fontFamily: "Inter !important",

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
            // '&:hover': {
            //   backgroundColor: "#f6f6f6",
            // },
          },
          "& .MuiInput-underline:before": {
            borderBottom: "none !important",
          },
          "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
        }}
      />
    </Box>
  );
};

export default DraftTable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
